import React, { createContext } from 'react';
import { BrowserRouter } from 'react-router-dom';
import {
  Switch,
  Route
} from "react-router-dom";
import RoutingRules from './RoutingRules'
import { useInformationForNotification } from '../hooks/useInformationForNotification';

export const RulesContext = createContext();

const RulesRouting = ({ruleEditActive}) => {
  const informationForCreatingNotification = useInformationForNotification();
  return (
    <RulesContext.Provider value={{ ruleEditActive, informationForCreatingNotification }}>
      <BrowserRouter>
        <Switch>
          <Route exact path="/routing_rules">
            <RoutingRules />
          </Route>
        </Switch>
      </BrowserRouter>
    </RulesContext.Provider>
  );
};

export default RulesRouting;
